export default __webpack_public_path__ + "static/media/vendor_icon_small.ff7a7457.svg";